import PlaceMenuMedia from "../../place-menu-media";
import Image from "next/image";
import { useTranslations } from "@/lib/static-intl";

const PDW_PlaceTabMenuSection = ({ placeMenus, openPlaceMediaSlider }) => {
  const t = useTranslations("places.place_details_window");

  return (
    <div className="w-full min-h-[70vh] flex flex-col divide-y divide-black/[0.08] dark:divide-white/[0.14]">
      {placeMenus && placeMenus?.length > 0 ? (
        <>
          {placeMenus?.map((_m, index) => (
            <div
              key={index}
              className="py-3 flex gap-4 items-start flex-row-reverse"
            >
              <PlaceMenuMedia
                menuId={_m?.id || _m?._id}
                menuFilePath={_m?.placeMenuMedia?.[0]?.filePath}
                menuMedia={_m?.placeMenuMedia?.[0]}
                openPlaceMediaSlider={openPlaceMediaSlider}
              />
              <div className="w-full flex flex-col gap-1.5 dark:text-white">
                <b>{_m["itemName"]}</b>
                {_m["itemPrice"] && (
                  <p>
                    <span className="font-medium">
                      {_m["itemPrice"]
                        ? isNaN(_m["itemPrice"])
                          ? _m["itemPrice"]
                          : new Intl.NumberFormat("en-US").format(
                              Number(_m["itemPrice"])
                            )
                        : ""}
                    </span>{" "}
                    {t("won")}
                  </p>
                )}
              </div>
            </div>
          ))}
        </>
      ) : (
        <div className="flex flex-col gap-2 items-center justify-center h-[300px]">
          <Image
            src={"/no-data.png"}
            alt="no-data"
            width={50}
            height={50}
            className="object-contain"
          />
          <span className="text-xs text-black/30 dark:text-white/30">
            {t("no_menu")}
          </span>
        </div>
      )}
    </div>
  );
};

export default PDW_PlaceTabMenuSection;
